import * as actionType from "./actionTypes";
import { customerRequest, setCustomerLoggedOutHandler } from "../../utils/customerApi";
import { processError } from "../../utils/apiHandlers";
import { LOADING_STATE, LS_ITEM, NOTIF_TYPE } from "../../utils/stateTypes";
import { loadCustomerTokens, storeCustomerTokens, clearCustomerTokens } from "../localStorage";
import _notif from "../notification";
import _shop from "../shop";

const setProfile = (profile) => (
  {
    type: actionType.SET_PROFILE,
    profile,
  }
);

/* =========================== START UP =========================== */

// Checks the saved login (refreshing it if needed), then loads the catalogue - with the Derma products if logged in
export const initCustomer = () => (
  async (dispatch) => {
    setCustomerLoggedOutHandler(() => dispatch(setProfile(null)));

    if (loadCustomerTokens().token) {
      try {
        dispatch(setProfile(await customerRequest("/Customer/Me")));
      }
      catch (e) {
        clearCustomerTokens();
      }
    }
    dispatch({ type: actionType.SET_CHECKED });
    dispatch(_shop.actions.loadProducts());
  }
);

/* =========================== LOGIN, REGISTER, LOGOUT =========================== */

//Saves the new login, then loads the customer's details and the catalogue with the Derma products
const loggedIn = (tokens) => (
  async (dispatch) => {
    storeCustomerTokens(tokens.token, tokens.refreshToken);
    dispatch(setProfile(await customerRequest("/Customer/Me")));
    dispatch(_shop.actions.loadProducts());
  }
);

//Posts an account form: lsItem shows the loading state, success gets the server's response
const submit = (lsItem, url, data, success) => (
  async (dispatch) => {
    dispatch(_notif.actions.setLoadState(lsItem, LOADING_STATE.LOADING));
    try {
      const result = await customerRequest(url, "POST", data);
      await success(result);
      dispatch(_notif.actions.setLoadState(lsItem, LOADING_STATE.LOADED));
    }
    catch (error) {
      processError(dispatch, _notif, lsItem)(error);
    }
  }
);

export const login = (email, password, onDone) => (
  (dispatch) => dispatch(submit(LS_ITEM.CUSTOMER_LOGIN, "/Customer/Login", { email, password }, async (tokens) => {
    await dispatch(loggedIn(tokens));
    onDone();
  }))
);

export const register = (details, onDone) => (
  (dispatch) => dispatch(submit(LS_ITEM.CUSTOMER_REGISTER, "/Customer/Register", details, async (tokens) => {
    await dispatch(loggedIn(tokens));
    dispatch(_notif.actions.queueNotification("Welcome! Your account is ready.", NOTIF_TYPE.SUCCESS));
    onDone();
  }))
);

export const logout = () => (
  (dispatch) => {
    //Revoke this device's login on the server (no need to wait for it)
    const { refreshToken } = loadCustomerTokens();
    customerRequest("/Customer/Logout", "POST", { refreshToken }).catch(() => {/* Logged out here regardless */});
    clearCustomerTokens();
    dispatch(setProfile(null));
    //Reloading the catalogue without the Derma products also takes them out of the cart
    dispatch(_shop.actions.loadProducts());
  }
);

/* =========================== PASSWORD RESET =========================== */

export const forgotPassword = (email, onDone) => (
  (dispatch) => dispatch(submit(LS_ITEM.CUSTOMER_FORGOT, "/Customer/ForgotPassword", { email }, async () => onDone()))
);

//A successful reset also logs the customer in
export const resetPassword = (email, token, password, onDone) => (
  (dispatch) => dispatch(submit(LS_ITEM.CUSTOMER_RESET, "/Customer/ResetPassword", { email, token, password }, async (tokens) => {
    await dispatch(loggedIn(tokens));
    dispatch(_notif.actions.queueNotification("Your password has been changed.", NOTIF_TYPE.SUCCESS));
    onDone();
  }))
);
